import { IntercomUpdateModel } from '../model/intercomModel';
import { PayloadIntercomUpdateModel } from '../model/intercomPayloadModel';

export const intercomToUpdatePayload = ({ name, vendor, id }: IntercomUpdateModel): PayloadIntercomUpdateModel => {
  return { name, vendor, id };
};
